module.exports = __webpack_public_path__ + "static/DSC_9350-9e0ebac25a3a8d094de29abdd18f395b.jpg";